import React, { useState } from "react";
import {
  TextField,
  Grid,
  InputLabel,
  Tooltip,
  IconButton,
  Divider,
  // SvgIcon,
} from "@common-ui/ui";
import throttle from "lodash/throttle";
import { useDispatch, useSelector } from "react-redux";
// import Address from "./Address";
import { useParams } from "react-router-dom";
import { setGroups, setItem } from "../../actions";
import { DeleteForever } from "@mui/icons-material";
import { deleteItem } from "../../services";
const MaintenanceItem = ({ groupIndex, taskIndex, task }) => {
  let params = useParams();
  const dispatch = useDispatch();
  const { groups } = useSelector((state) => state["maintenancePlan"]);
  const [taskItems, setTaskItems] = useState(task);
  const handleChangeItem = (e) => {
    let { name, value } = e.target;
    setTaskItems({ ...taskItems, [name]: value });
    updateGroupRow({
      item: { ...taskItems, [name]: value },
      groupIndex,
      taskIndex,
    });
  };

  const updateGroupRow = React.useMemo(
    () =>
      throttle((request) => {
        dispatch(setItem(request.item, request.groupIndex, request.taskIndex));
      }, 200),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return (
    <>
      <Grid container spacing={2}>
        <>
          <Grid item md={2.8} xs={12}>
            <div>
              <InputLabel>Name</InputLabel>
              <TextField
                sx={{ mt: 1 }}
                size="small"
                autoComplete="off"
                fullWidth
                placeholder="Type"
                margin="normal"
                name="name"
                onChange={(e) => handleChangeItem(e)}
                value={taskItems["name"]}
                variant="outlined"
              />
            </div>
          </Grid>
          <Grid item md={2.8} xs={12}>
            <div>
              <InputLabel>Description</InputLabel>
              <TextField
                sx={{ mt: 1 }}
                size="small"
                autoComplete="off"
                fullWidth
                placeholder="Type"
                margin="normal"
                name="description"
                onChange={(e) => handleChangeItem(e)}
                value={taskItems["description"]}
                variant="outlined"
              />
            </div>
          </Grid>
          <Grid item md={2.8} xs={12}>
            <div>
              <InputLabel>Service</InputLabel>
              <TextField
                sx={{ mt: 1 }}
                size="small"
                autoComplete="off"
                fullWidth
                placeholder="Type"
                margin="normal"
                name="service"
                onChange={(e) => handleChangeItem(e)}
                value={taskItems["service"]}
                variant="outlined"
              />
            </div>
          </Grid>
          <Grid item md={2.8} xs={12}>
            <div>
              <InputLabel>Assignee</InputLabel>
              <TextField
                sx={{ mt: 1 }}
                size="small"
                autoComplete="off"
                fullWidth
                placeholder="Type"
                margin="normal"
                name="assignee"
                onChange={(e) => handleChangeItem(e)}
                value={taskItems["assignee"]}
                variant="outlined"
              />
            </div>
          </Grid>
          <Grid item md={0.8} xs={12}>
            <Tooltip title="Remove Item">
              <IconButton
                sx={{ mt: { md: 3.5 } }}
                onClick={async () => {
                  const newGroups = groups.map((newGroup, i) => {
                    if (i === groupIndex) {
                      return {
                        ...newGroup,
                        items: newGroup.items.filter(
                          (element, elementIndex) => {
                            return elementIndex !== taskIndex;
                          }
                        ),
                      };
                    } else return newGroup;
                  });
                  if (task.system_id) {
                    // console.log(params.id, task.group);
                    try {
                      await deleteItem(
                        params?.orgId,
                        params?.id,
                        task.group,
                        task.system_id
                      );
                      // console.log("deleted", payload);
                    } catch (error) {
                      console.log(error);
                    }
                  }
                  dispatch(setGroups(newGroups));
                }}
              >
                <DeleteForever />
              </IconButton>
            </Tooltip>
          </Grid>
        </>
      </Grid>
      <Divider
        sx={{ mb: 1, mt: 2, cursor: "pointer" }}
        // onClick={() => alert("Coming Soon!")}
      >
        {/* <SvgIcon>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g fill="#DFE1E5">
              <g transform="translate(3.000000, 2.000000)">
                <rect x="0" y="7" width="18" height="2"></rect>
                <rect x="0" y="11" width="18" height="2"></rect>
                <path d="M5.29175912,15.2930586 C4.90274696,15.685137 4.90274696,16.3202641 5.29175912,16.7123425 L8.23085096,19.6779356 C8.44885778,19.8929786 8.73086659,20 9.00987531,20 C9.28888403,20 9.56589268,19.8929786 9.77889934,19.6779356 L12.7089909,16.7223445 C13.097003,16.3302661 13.097003,15.695139 12.7089909,15.3030606 C12.3199787,14.9109822 11.6909591,14.9109822 11.302947,15.3030606 L9.00487515,17.6205241 L6.69780306,15.2930586 C6.50379699,15.0980196 6.24878902,15 5.99478109,15 C5.73977312,15 5.48476515,15.0980196 5.29175912,15.2930586 Z"></path>
                <path
                  d="M5.29175912,0.293058612 C4.90274696,0.685137027 4.90274696,1.32026405 5.29175912,1.71234247 L8.23085096,4.67793559 C8.44885778,4.8929786 8.73086659,5 9.00987531,5 C9.28888403,5 9.56589268,4.8929786 9.77889934,4.67793559 L12.7089909,1.72234447 C13.097003,1.33026605 13.097003,0.695139028 12.7089909,0.303060612 C12.3199787,-0.0890178036 11.6909591,-0.0890178036 11.302947,0.303060612 L9.00487515,2.6205241 L6.69780306,0.293058612 C6.50379699,0.0980196039 6.24878902,0 5.99478109,0 C5.73977312,0 5.48476515,0.0980196039 5.29175912,0.293058612 Z"
                  transform="translate(9.000000, 2.500000) rotate(180.000000) translate(-9.000000, -2.500000) "
                ></path>
              </g>
            </g>
          </g>
        </SvgIcon> */}
      </Divider>
    </>
  );
};

export default React.memo(MaintenanceItem);
